import { alveolarPressure } from "../physics/pressure.js";
import type { GasMix, TissueSnapshot } from "../types.js";
import { N_COMPARTMENTS, ZHL16C, kN2 } from "./constants.js";
import { mValueAtDepth } from "./m-values.js";

export function ndlAtDepth(
  state: TissueSnapshot,
  depth: number,
  gas: GasMix,
  surfaceGf: number = 1,
): number | null {
  const pInspired = alveolarPressure(depth) * gas.fN2;
  let minTime = Infinity;

  for (let i = 0; i < N_COMPARTMENTS; i++) {
    const cpt = ZHL16C[i]!;
    const k = kN2(cpt);
    const p0 = state.pN2[i]!;
    const mSurfaceRaw = mValueAtDepth(0, cpt.aN2, cpt.bN2);
    const mSurface = surfaceGf >= 1 ? mSurfaceRaw : 1 + surfaceGf * (mSurfaceRaw - 1);

    if (pInspired <= mSurface) continue;
    if (p0 >= mSurface) return 0;

    const t = (-1 / k) * Math.log((pInspired - mSurface) / (pInspired - p0));
    if (t > 0 && t < minTime) minTime = t;
  }

  if (!Number.isFinite(minTime)) return null;
  return minTime;
}
